import { ParamsAdapter } from '../../params.adapter';

import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';

import { ApiBaseMidBack } from './base';
import { CreateProfileRequest } from './types/createProfileRequest';
import { PointViewModel } from './types/pointViewModel';
import { ProfileViewModel } from './types/profileViewModel';

/**
 * @internal
 */
export class ApiMidbackNetwork extends ApiBaseMidBack {
  /**
   * Get delivery points filtered by deliveryPoint if provided
   */
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getGePoints(accountId: number, gridOperatorCode?: string, mpCode?: string) {
    const params = {};
    if (accountId) params['accountId'] = accountId;
    if (gridOperatorCode) params['gridOperatorCode'] = gridOperatorCode;
    if (mpCode) params['mpCode'] = mpCode;
    // TODO: #typing
    return this.get(`/network/ge-points`, new DefaultParams(params));
  }

  /**
   * Get delivery points filtered by pointTypeCode
   */
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getPointByType(typeCode: string) {
    return this.get<PointViewModel>(`/network/point`, new DefaultParams({ point_type_code: typeCode }));
  }

  @ApiOptions({ channel: 'logisticGasProfile', interceptErrors: false })
  getGasProfile(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get<ProfileViewModel>(`/network/ngfr/profiles/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticGasProfile', interceptErrors: false })
  putGasProfile(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.post<CreateProfileRequest>(`/network/ngfr/profiles/${gridOperator}/${meteringPoint}`, params);
  }
}
